/**
 * @mock coming-up-events
 * @swap-with EventCatalog table + endpoint
 * @flag VITE_MOCK_EVENTS
 * @reqs A-3
 * @plan docs/impl-plans/registered-student-frontend-prototype.md (M6.4)
 *
 * Static seed of upcoming academic events for the "Coming Up for You" strip.
 * Dates are relative offsets resolved at read time so the demo always shows future events.
 */
import type { ComingUpEvent } from '@/types/registeredStudent';

interface EventSeed {
  id: string;
  name: string;
  daysFromNow: number;
  type: ComingUpEvent['type'];
  subjectTags: string[];
  gradeBands: string[];
  curriculumTags: string[];
}

const SEEDS: EventSeed[] = [
  { id: 'jee-mains-s1', name: 'JEE Mains Session 1', daysFromNow: 334, type: 'COMPETITIVE_EXAM', subjectTags: ['Mathematics', 'Physics', 'Chemistry'], gradeBands: ['GRADE_11_12'], curriculumTags: ['CBSE'] },
  { id: 'cbse-12-boards', name: 'CBSE Class 12 Board Exams', daysFromNow: 270, type: 'BOARD_EXAM', subjectTags: [], gradeBands: ['GRADE_11_12'], curriculumTags: ['CBSE'] },
  { id: 'cbse-10-boards', name: 'CBSE Class 10 Board Exams', daysFromNow: 250, type: 'BOARD_EXAM', subjectTags: [], gradeBands: ['GRADE_10'], curriculumTags: ['CBSE'] },
  { id: 'imo', name: 'International Maths Olympiad', daysFromNow: 185, type: 'OLYMPIAD', subjectTags: ['Mathematics'], gradeBands: ['MIDDLE_SCHOOL', 'GRADE_10', 'GRADE_11_12'], curriculumTags: [] },
  { id: 'ntse-1', name: 'NTSE Stage 1', daysFromNow: 92, type: 'SCHOLARSHIP', subjectTags: [], gradeBands: ['GRADE_10'], curriculumTags: [] },
  { id: 'neet', name: 'NEET', daysFromNow: 320, type: 'COMPETITIVE_EXAM', subjectTags: ['Biology', 'Physics', 'Chemistry'], gradeBands: ['GRADE_11_12'], curriculumTags: ['CBSE'] },
];

function isoDateInDays(days: number): string {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
}

export function getComingUpEvents(): ComingUpEvent[] {
  return SEEDS.map((s) => ({
    id: s.id,
    name: s.name,
    eventDate: isoDateInDays(s.daysFromNow),
    type: s.type,
    subjectTags: s.subjectTags,
    gradeBands: s.gradeBands,
    curriculumTags: s.curriculumTags,
  })).sort((a, b) => a.eventDate.localeCompare(b.eventDate));
}
